import {ff, HorizontalLoader} from 'mc/lib';
import {Form, FormBody} from 'mc/lib/form';
import React from 'react';
import {Button, Col, Row} from 'reactstrap';
import {formValueSelector, reduxForm} from 'redux-form';
import {requireFields} from "mc/lib/utils";
import ReCaptcha from 'react-google-recaptcha';
import {connect} from 'react-redux';

const validateRequiredFields = requireFields(['email', 'jmeno', 'prijmeni', 'datumNarozeni', 'cisloObcanskehoPrukazu', 'adresa'], "Údaj je povinný");

/**
 * Formulář pro registraci.
 */
class RegistraceForm extends React.Component {

    static validate(values, props) {
        const errors = validateRequiredFields(values);
        return errors;
    }

    static formName = 'registraceForm';

    static propTypes = {
    };

    static defaultProps = {
    };

    handleReCaptchaChange = value => {
        this.props.change('reCaptchaResponse', value);
    };

    render() {
        const {onClose, submitting, handleSubmit, reCaptchaSiteKey, reCaptchaResponse, text} = this.props;

        const submitDisabled = reCaptchaSiteKey && !reCaptchaResponse; // Capcha je vyžadována, ale uživatel ji ještě nevyplnil

        return (
            <Form onSubmit={handleSubmit}>
                {submitting && <HorizontalLoader/>}
                <div className="registrace">
                    <h1>Žádost o registraci</h1>
                    <FormBody>
                        <Row className="registrace-row">
                            <Col className="registrace-input" sm={12} lg={6}>
                                <ff.String label={false} placeholder="Jméno" name="jmeno" required  disabled={submitting}/>
                            </Col>
                            <Col className="registrace-input" sm={12} lg={6}>
                                <ff.String label={false} placeholder="Příjmení" name="prijmeni" required  disabled={submitting}/>
                            </Col>
                        </Row>
                        <Row className="registrace-row">
                            <Col className="registrace-input" sm={10} lg={5}>
                                <ff.SimpleDate label={false} placeholder="Datum narozeni" name="datumNarozeni" required disabled={submitting}/>
                            </Col>
                            <Col className="registrace-input" sm={10} lg={5}>
                                <ff.String label={false} placeholder="Číslo občanského průkazu" name="cisloObcanskehoPrukazu" required  disabled={submitting}/>
                            </Col>
                        </Row>
                        <Row className="registrace-row">
                            <Col className="registrace-input">
                                <ff.Adresa label={false} placeholder="Adresa trvalého pobytu" name="adresa" required  disabled={submitting}/>
                            </Col>
                        </Row>
                        <Row className="registrace-row">
                            <Col className="registrace-input" lg={10}>
                                <ff.String label={false} placeholder="E-mail" name="email" required  disabled={submitting}/>
                            </Col>
                        </Row>
                    </FormBody>
                    {text && (<div className="registrace-text" dangerouslySetInnerHTML={{__html: text}}>
                    </div>)}
                    {reCaptchaSiteKey && (
                        <ReCaptcha className="mt-2" sitekey={reCaptchaSiteKey} onChange={this.handleReCaptchaChange}/>
                    )}
                    <Button className={"registrace-button-submit"} key={"submit"}
                            type="submit" disabled={submitDisabled || submitting}>{"Odeslat"}</Button>
                    <Button className={"registrace-button"} key={"cancel"} type="button" disabled={submitting} onClick={onClose}>{"Zrušit"}</Button>
                </div>
            </Form>
        );
    }
}

const registraceFormValueSelector = formValueSelector(RegistraceForm.formName);

const mapStateToProps = (state, props) => ({
    reCaptchaResponse: registraceFormValueSelector(state, 'reCaptchaResponse'),
});

const formConfig = {
    form: RegistraceForm.formName,
    validate: RegistraceForm.validate,
};

export default connect(mapStateToProps)(reduxForm(formConfig)(RegistraceForm));
